import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getSellers as getSellersApi,
  addSellers as addSellersApi,
  updateSellers as updateSellersApi,
  deleteSellers as deleteSellersApi,
  getProductGrid as getProductGridApi,
  addProductGrid as addProductGridApi,
  updateProductGrid as updateProductGridApi,
  deleteProductGrid as deleteProductGridApi,
  getReview as getReviewApi,
  addReview as addReviewApi,
  updateReview as updateReviewApi,
  deleteReview as deleteReviewApi,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { createProduct, deleteProduct, listProducts, updateProduct } from "services/product.service";
import {
  doCreateCustomOrder,
  doCreateOrder,
  doListCustomOrder,
  doListOrder,
  doUpdateCustomOrder,
  doUpdateCustomOrderStatus,
  doUpdateOrder,
  doUpdateOrderStatus,
} from "../../services/order.service";

export const onGetOrders = createAsyncThunk("ecommerce/getOrders", async () => {
  try {
    const response = await doListOrder(0);
    return response;
  } catch (error) {
    return error;
  }
});
export const onAddOrder = createAsyncThunk("ecommerce/addOrders", async (event: any) => {
  try {
    const response = doCreateOrder(event);
    const data = await response;
    toast.success("Order Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Order Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateOrder = createAsyncThunk("ecommerce/updateOrders", async (event: any) => {
  try {
    const response = doUpdateOrder(event);
    const data = await response;
    toast.success("Order updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Order updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateOrderStatus = createAsyncThunk("ecommerce/updateOrderStatus", async (event: any) => {
  try {
    const response = doUpdateOrderStatus(event.orderId, event.status);
    const data = await response;
    toast.success("Order updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Order updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onGetCustomOrders = createAsyncThunk("ecommerce/getCustomOrders", async () => {
  try {
    const response = await doListCustomOrder(0);
    return response;
  } catch (error) {
    return error;
  }
});

export const onAddCustomOrder = createAsyncThunk("ecommerce/addCustomOrders", async (event: any) => {
  try {
    const response = doCreateCustomOrder(event);
    const data = await response;
    toast.success("Order Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Order Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateCustomOrder = createAsyncThunk("ecommerce/updateCustomOrders", async (event: any) => {
  try {
    const response = doUpdateCustomOrder(event);
    const data = await response;
    toast.success("Order updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Order updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateCustomOrderStatus = createAsyncThunk("ecommerce/updateCustomOrderStatus", async (event: any) => {
  try {
    const response = doUpdateCustomOrderStatus(event.orderCustomId, event.status);
    const data = await response;
    toast.success("Order updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Order updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const getSellers = createAsyncThunk("ecommerce/getSellers", async () => {
  try {
    const response = getSellersApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addSellers = createAsyncThunk("ecommerce/addSellers", async (event: any) => {
  try {
    const response = addSellersApi(event);
    const data = await response;
    toast.success("Seller Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Seller Added Failed", { autoClose: 2000 });
    return error;
  }
});
export const updateSellers = createAsyncThunk("ecommerce/updateSellers", async (event: any) => {
  try {
    const response = updateSellersApi(event);
    const data = await response;
    toast.success("Seller updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Seller updated Failed", { autoClose: 2000 });
    return error;
  }
});
export const deleteSellers = createAsyncThunk("ecommerce/deleteSellers", async (event: any) => {
  try {
    const response = deleteSellersApi(event);
    toast.success("Seller deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Seller deleted Failed", { autoClose: 2000 });
    return error;
  }
});

export const getProductList = createAsyncThunk("ecommerce/getProductList", async () => {
  try {
    const response: any = await listProducts(0);
    return response.data;
  } catch (error) {
    return error;
  }
});
export const addProductList = createAsyncThunk("ecommerce/addProductList", async (params: any) => {
  try {
    const response = createProduct(params);
    const data = await response;
    toast.success("Product Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Data Added Failed", { autoClose: 2000 });
    return error;
  }
});
export const updateProductList = createAsyncThunk("ecommerce/updateProductList", async (event: any) => {
  try {
    const response = updateProduct(event);
    const data = await response;
    toast.success("Data updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Data updated Failed", { autoClose: 2000 });
    return error;
  }
});
export const deleteProductList = createAsyncThunk("ecommerce/deleteProductList", async (id: string) => {
  try {
    const response = deleteProduct(id);
    toast.success("Data deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Data deleted Failed", { autoClose: 2000 });
    return error;
  }
});

export const getProductGrid = createAsyncThunk("ecommerce/getProductGrid", async () => {
  try {
    const response = getProductGridApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addProductGrid = createAsyncThunk("ecommerce/addProductGrid", async (event: any) => {
  try {
    const response = addProductGridApi(event);
    const data = await response;
    toast.success("Data Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Data Added Failed", { autoClose: 2000 });
    return error;
  }
});
export const updateProductGrid = createAsyncThunk("ecommerce/updateProductGrid", async (event: any) => {
  try {
    const response = updateProductGridApi(event);
    const data = await response;
    toast.success("Data updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Data updated Failed", { autoClose: 2000 });
    return error;
  }
});
export const deleteProductGrid = createAsyncThunk("ecommerce/deleteProductGrid", async (event: any) => {
  try {
    const response = deleteProductGridApi(event);
    toast.success("Data deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Data deleted Failed", { autoClose: 2000 });
    return error;
  }
});

export const getReview = createAsyncThunk("ecommerce/getReview", async () => {
  try {
    const response = getReviewApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addReview = createAsyncThunk("ecommerce/addReview", async (event: any) => {
  try {
    const response = addReviewApi(event);
    const data = await response;
    toast.success("Data Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Data Added Failed", { autoClose: 2000 });
    return error;
  }
});
export const updateReview = createAsyncThunk("ecommerce/updateReview", async (event: any) => {
  try {
    const response = updateReviewApi(event);
    const data = await response;
    toast.success("Data updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Data updated Failed", { autoClose: 2000 });
    return error;
  }
});
export const deleteReview = createAsyncThunk("ecommerce/deleteReview", async (event: any) => {
  try {
    const response = deleteReviewApi(event);
    toast.success("Data deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Data deleted Failed", { autoClose: 2000 });
    return error;
  }
});
